import axios from "axios";

import initInterceptors from "./interceptors";

import type { AxiosResponse } from "axios";

import type { ICart } from "@/interfaces/ICart";

const getToken = (): string => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const token = params.get("t");
  return token ?? "";
};

const formatToken = (token: string) => `Bearer ${token}`;

const api = axios.create({
  timeout: 60000,
  headers: {
    Authorization: formatToken(getToken()),
    "x-api-key": import.meta.env.VITE_API_KEY ?? "",
  },
});

initInterceptors(api);

export default class apiService {
  // static submitContactForm = (formData: any) => {
  //     const url = import.meta.env.VITE_API_CONTACT_FORM_URL || ''
  //     return api.post(url, {
  //         data: formData
  //     });
  // }

  static fetchProduct = async (productSlug: string): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.get(`${url}/product/${productSlug}`);
  };

  static fetchBlog = async (blogId: string): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.get(`${url}/blogs/${blogId}`);
  };

  static fetchBlogs = async (
    limit: number,
    last_key?: any,
  ): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.get(`${url}/blogs`, {
      params: {
        limit,
        last_key: JSON.stringify(last_key),
      },
    });
  };

  static fetchProjects = async (
    limit: number,
    last_key?: any,
  ): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.get(`${url}/projects`, {
      params: {
        limit,
        last_key: JSON.stringify(last_key),
      },
    });
  };

  static fetchProject = async (projectId: string): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.get(`${url}/projects/${projectId}`);
  };

  static fetchEvents = async (
    limit: number,
    last_key?: any,
  ): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.get(`${url}/events`, {
      params: {
        limit,
        last_key: JSON.stringify(last_key),
      },
    });
  };

  static checkout = async (cart: ICart): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";

    if (cart.id && cart.id !== "") {
      return api.patch(`${url}/update-payment-intent/${cart.id}`, cart);
    }
    return api.post(`${url}/create-payment-intent`, cart);
  };

  static reserve = async (
    sessionId?: string,
    metadata?: any,
  ): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    if (sessionId) {
      return api.patch(
        `${url}/reserve/checkout-session/${sessionId}`,
        metadata,
      );
    }
    return api.get(`${url}/reserve/checkout-session`);
  };

  static unsubscribe = async (token: string): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.post(`${url}/preferences/unsubscribe`, {
      token,
    });
  };

  static contact = async (data: any): Promise<AxiosResponse> => {
    const url = import.meta.env.VITE_API_URL ?? "";
    return api.post(`${url}/leads/contact`, data);
  };
}
